module.exports = __webpack_public_path__ + "img/blog10.16962387.png";